import jqRequest from '../jqRequest'
import inviteUrls from '../urls/invite'

export default {
  // 获取发出邀请用户的信息
  getInviterInfo(data) {
    return jqRequest.requestWithToken(inviteUrls.getInviterInfo, data);
  },
}